<script>
  import '$styles/tailwind.css';
  import '$styles/general.css';
  import '$styles/font.css';
  import '$styles/skeleton.css';

  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query';
  import { browser } from '$app/environment';
  import { onMount } from 'svelte';
  import { getMe } from '$src/utils/api/user.util';
  import { useScrollVersion } from '$lib/components/homepage/top-island';
  import StoreViewer from './debug/_components/StoreViewer.svelte';

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        enabled: browser
      }
    }
  });
  let prevScrollTop = 0;
  let scrollHandler = () => {
    if (document.documentElement.scrollTop !== prevScrollTop) {
      if (document.documentElement.scrollTop === 0) {
        useScrollVersion.set(false);
      }

      const scrolledDown = document.documentElement.scrollTop > prevScrollTop;
      useScrollVersion.set(scrolledDown);
      prevScrollTop = document.documentElement.scrollTop;
    }
  };

  onMount(() => {
    // This is the scroll event listener that will set the scroll version
    // the other one doesnt get triggered for some reason unless you set all the divs leading to it as h-screen
    window.addEventListener('scroll', scrollHandler, { capture: true });
    getMe();
  });
</script>

<svelte:head>
  <title>The Garden Platform</title>
  <meta
    name="description"
    content="The Garden is a safe space to share, recognize and grow talent. Gardeners (Community members) can put their gifts on display, collaborate, and encourage others to reach higher. It´s where you can be admired and recognized for who you truly are."
  />
</svelte:head>

<StoreViewer />


<QueryClientProvider client={queryClient}>
  <slot />
</QueryClientProvider>
